import * as tslib_1 from "tslib";
import { Exclude } from 'class-transformer';
export class WorkflowCheckListItemResultDto {
}
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", String)
], WorkflowCheckListItemResultDto.prototype, "camStatus", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", String)
], WorkflowCheckListItemResultDto.prototype, "camComments", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", String)
], WorkflowCheckListItemResultDto.prototype, "acctStatus", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", String)
], WorkflowCheckListItemResultDto.prototype, "acctComments", void 0);
